const en = {
  whatWeDo: 'What We Do',
  pricing: 'Pricing',
  order: 'Order',
  needHelp: 'Need Help?',
  takeYourBusiness: 'Take your business to',
  theNextLevel: 'the next level',
  getStartedIn: 'Get started in less then 10 minutes and get',
  qualityWebsite: 'a quality website',
  justWeek: 'in just a week',
  getStarted: 'Get started',
  getFreeConsult: 'Get a free consult',
  professionalAndEffective:
    'Professional and effective websites tailored to your needs',
  weLikeToKeepThings:
    'We like to keep things simple and affordable when delivering quality websites. Whether you need to refresh your current look or create a new one, we’ve got you covered.',
  reliableHosting: 'Reliable hosting',
  fullyResponsive: 'Fully responsive',
  userFriendly: 'User friendly',
  ourPlansPricing: 'Our plans & pricing',
  selectPlan: 'Select a plan that suits your business needs',
  basicPlan: 'Basic Plan',
  alreadyHaveWebsite: 'Already have a website and looking for a new look?',
  landingPage: 'Landing Page',
  starterPlan: 'Starter Plan',
  dontHaveWebsite:
    'Don’t have a website and want to make a new one from scratch',
  landingPageHosting: 'Landing Page + Web Hosting',
  fullPlan: 'Full Plan',
  startingNewBusiness: 'Starting a new business, need a brand and a website?',
  brandingLandingPageHosting: 'Branding + Landing Page + Web Hosting',
  gettingStarted: 'Getting started',
  weDeliverMore: 'We deliver more than just websites',
  wheterYouAlreadyHave:
    'Whether you already have an existing website or plan to start a new one, we offer a range of web & design services to cater your needs. We work with you to create a visual foundation and provide you with the tools you need to grow your business.',
  singlePage:
    'Single page website with up to 6 subsections customized to your content',
  webHosting: 'Web hosting',
  fastAndReliable:
    'Fast and reliable international level hosting with SSL certification',
  emailHosting: 'Email hosting',
  secureAndReliable:
    'Secure and reliable anti-spam email hosting for your business',
  brandDesign: 'Brand design',
  professionalBrandGuideline:
    'Professional brand guideline perfect for building a great visual foundation',
  logoDesign: 'Logo design',
  customLogo:
    'Custom logo that makes your business look sharp and professional',
  domainServices: 'Domain services',
  easyAndHassleFree: 'Easy and hassle-free management for your business domain',
  testimonials: 'Testimonials',
  whatOurClientSay: 'What our clients say',
  weLoveHowWebsnap:
    '“We love how Websnap has helped us improve our image, our website now looks great and professional.”',
  headOfOperation: 'Head of Operations of PG3 Ag.',
  readyToLevelUp: 'Ready to level up?',
  startGrowing: 'Start growing your online presence today',
  websnapSpecialize:
    'WebSnap specializes in creating professional and effective web design solutions tailored to your business needs.',
  madeWithLove: 'Made with ♥ in Switzerland.',
  copyright: 'Copyright © 2023 WebSnap All Rights Reserved.',
};

export default en